<template>
    <section class="home-container">
        <MasterPage title="检测项目管理">
            <div slot="title-icon">
                <Icon type="ios-albums" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="100">
                    <Row>
                        <Col span="24">
                        <FormItem label="项目状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增检测项目" width="50%" @on-cancel="cancelItem">
            <Form :label-width="120">
                <FormItem label="检测名称：">
                    <Input v-model="itemAdd.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="检测介绍：">
                    <Input v-model="itemAdd.introduction" type="textarea" :autosize="{minRows:3,maxRows: 5}" placeholder="请输入" />
                </FormItem>
                <FormItem label="检测价格：">
                    <InputNumber :min="0" style="width: 100%" v-model="itemAdd.price" placeholder="请输入" />
                </FormItem>
            </Form>
            <div style="line-height: 50px">检测详情：</div>
            <!-- <div id="editor"></div> -->
            <MyEditor @update:editorContent="contentUpdate" />

            <div style="line-height: 50px">其它介绍：</div>
            <!-- <div id="otherIntroEditor"></div> -->
            <MyEditor @update:editorContent="otherContentUpdate" />
            <div style="line-height: 50px">操作视频：</div>
            <div style="display: flex;align-items: center">
                <video :src="baseURL + itemAdd.videoUrl" style="height: 200px;margin: auto" controls="controls" v-if="itemAdd.videoUrl != null"></video>
            </div>
            <Upload
                    ref="uploadImageAdd"
                    multiple
                    type="drag"
                    :on-success="fileSuccess"
                    :on-error="fileError"
                    action="food/file/upload">
                <!--<div :style="{padding:'32px 0',backgroundImage: 'url(\'' + itemAdd.videoUrl + '\')',backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition: 'center' }">-->
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>单击或拖动视频以上传</p>
                <!--</div>-->
            </Upload>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改检测项目" width="50%" @on-cancel="cancelItem">
            <Form :label-width="120">
                <FormItem label="检测项目名称：">
                    <Input v-model="updateInfoItem.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="检测项目介绍：">
                    <Input v-model="updateInfoItem.introduction" type="textarea" :autosize="{minRows:3,maxRows: 5}" placeholder="请输入" />
                </FormItem>
                <FormItem label="检测项目价格：">
                    <InputNumber :min="0" style="width: 100%" v-model="updateInfoItem.price" placeholder="请输入" />
                </FormItem>
            </Form>
            <div style="line-height: 50px">检测详情：</div>
            <!-- <div id="editorUpdate"></div> -->
            <MyEditor :editorContent="editArticleContent" @update:editorContent="contentUpdate" />
            <div style="line-height: 50px">其它介绍：
                <!--<Button type="primary" size="small" @click="otherIntroEditorUpdate.txt.html('')">清除</Button>-->
            </div>
            <!-- <div id="otherIntroEditorUpdate"></div> -->
            <MyEditor :editorContent="editOtherContent" @update:editorContent="otherContentUpdate" />
            <div style="line-height: 50px">操作视频：</div>
            <div style="display: flex;align-items: center">
                <video :src="baseURL + updateInfoItem.videoUrl" style="height: 200px;margin: auto" controls="controls" v-if="updateInfoItem.videoUrl != null"></video>
            </div>
            <Upload
                    ref="uploadImageUpdate"
                    multiple
                    type="drag"
                    :on-success="fileSuccess_update"
                    :on-error="fileError"
                    action="food/file/upload">
                <!--<div :style="{padding:'32px 0',backgroundImage: 'url(\'' + updateInfoItem.videoUrl + '\')',backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition: 'center' }">-->

                    <Icon type="ios-cloud-upload" size="26" style="color: #3399ff"></Icon>
                    <p>单击或拖动视频以上传</p>
                <!--</div>-->
            </Upload>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="检测项目详情">
            <Form :label-width="120">
                <FormItem  label="检测项目名称：">
                    {{infoItem.name}}
                </FormItem>
                <FormItem label="检测项目介绍：">
                    {{infoItem.introduction}}
                </FormItem>
                <FormItem label="检测项目价格：">
                    {{infoItem.price}}
                </FormItem>
            </Form>
            <div style="line-height: 50px">检测详情：</div>
            <div v-html="infoItem.content"></div>
            <div style="line-height: 50px">其它介绍：</div>
            <div v-html="infoItem.otherIntro"></div>

            <div style="line-height: 50px">操作视频：</div>
            <div style="display: flex;align-items: center">
                <video :src="baseURL + infoItem.videoUrl" style="height: 200px;margin: auto" controls="controls" v-if="infoItem.videoUrl != null"></video>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    import MyEditor  from '@/components/MyEditor'
    var E = require('wangeditor')
    import {baseURL} from '../../json/common'
    export default {
        components:{
            MasterPage,
            MyEditor
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '检测项目名称',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '检测项目介绍',
                        key: 'introduction',
                        tooltip: true,
                        align: 'center',
                    },
                    {
                        title: '检测项目价格',
                        key: 'price',
                        align: 'center',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                select:{
                    name:'',
                    introduction:'',
                    price:'',
                    isDeleted:'false',
                },
                itemAdd:{
                    name:'',
                    introduction:'',
                    price:0,
                    videoUrl: null,
                    otherIntro: ''
                },
                updateInfoItem: {},
                infoItem:'',
                editor:null,
                otherIntroEditor: null,
                editorUpdate:null,
                otherIntroEditorUpdate: null,
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                baseURL:baseURL,
                addArticleContent: '',
                addOtherContent: '',
                editArticleContent: '',
                editOtherContent: '',
            }
        },
        created(){
            this.pageFindItem()
        },
        mounted(){
            // let editor = new E('#editor')
            // let menus = [
            //     'head',  // 标题
            //     'bold',  // 粗体
            //     'fontSize',  // 字号
            //     'fontName',  // 字体
            //     'italic',  // 斜体
            //     'underline',  // 下划线
            //     'strikeThrough',  // 删除线
            //     'foreColor',  // 文字颜色
            //     'backColor',  // 背景颜色
            //     'list',  // 列表
            //     'justify',  // 对齐方式
            //     'quote',  // 引用
            //     'emoticon',  // 表情
            //     'image',  // 插入图片
            //     'table',  // 表格
            //     'undo',  // 撤销
            //     'redo'  // 重复
            // ]
            // editor.customConfig.uploadImgShowBase64 = true
            // editor.customConfig.menus = menus
            // editor.customConfig.uploadImgMaxSize = 64 * 1024
            // editor.customConfig.uploadImgServer = 'food/file/upload'
            // editor.customConfig.uploadFileName = 'file'
            // editor.customConfig.uploadImgHooks = {
            //     customInsert: (insertImg, result, editor) => {
            //         insertImg(this.baseURL + result.data.replace(/\\/g,"/"))
            //     }
            // }
            // editor.create()
            // this.editor = editor

            // let otherIntroEditor = new E('#otherIntroEditor')
            // otherIntroEditor.customConfig.uploadImgShowBase64 = true
            // otherIntroEditor.customConfig.menus = menus
            // otherIntroEditor.customConfig.uploadImgMaxSize = 64 * 1024
            // otherIntroEditor.customConfig.uploadImgServer = 'food/file/upload'
            // otherIntroEditor.customConfig.uploadFileName = 'file'
            // otherIntroEditor.customConfig.uploadImgHooks = {
            //     customInsert: (insertImg, result, editor) => {
            //         insertImg(this.baseURL + result.data.replace(/\\/g,"/"))
            //     }
            // }
            // otherIntroEditor.create()
            // this.otherIntroEditor = otherIntroEditor

            // let editorUpdate = new E('#editorUpdate')
            // editorUpdate.customConfig.uploadImgShowBase64 = true
            // editorUpdate.customConfig.menus = menus
            // editorUpdate.customConfig.uploadImgMaxSize = 64 * 1024
            // editorUpdate.customConfig.uploadImgServer = 'food/file/upload'
            // editorUpdate.customConfig.uploadFileName = 'file'
            // editorUpdate.customConfig.uploadImgHooks = {
            //     customInsert: (insertImg, result, editor) => {
            //         insertImg(this.baseURL + result.data.replace(/\\/g,"/"))
            //     }
            // }
            // editorUpdate.create()
            // this.editorUpdate = editorUpdate

            // let otherIntroEditorUpdate = new E('#otherIntroEditorUpdate')
            // otherIntroEditorUpdate.customConfig.uploadImgShowBase64 = true
            // otherIntroEditorUpdate.customConfig.menus = menus
            // otherIntroEditorUpdate.customConfig.uploadImgMaxSize = 64 * 1024
            // otherIntroEditorUpdate.customConfig.uploadImgServer = 'food/file/upload'
            // otherIntroEditorUpdate.customConfig.uploadFileName = 'file'
            // otherIntroEditorUpdate.customConfig.uploadImgHooks = {
            //     customInsert: (insertImg, result, editor) => {
            //         insertImg(this.baseURL + result.data.replace(/\\/g,"/"))
            //     }
            // }
            // otherIntroEditorUpdate.create()
            // this.otherIntroEditorUpdate = otherIntroEditorUpdate
        },
        methods:{
            contentUpdate (content) {
              if (this.addModel) {
                this.addArticleContent = content
              } else {
                this.editArticleContent = content
              }
            },
            otherContentUpdate(content) {
              if (this.addModel) {
                this.addOtherContent = content
              } else {
                this.editOtherContent = content
              }
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },

            fileError(error){
                this.$Notice.error({title:'文件上传成功',desc: error.message});
            },
            fileSuccess(response){
                this.$Notice.success({title:'文件上传成功'});
                this.itemAdd.videoUrl = response.data.replace(/\\/g,"/")
            },
            fileSuccess_update(response){
                this.$Notice.success({title:'文件上传成功'});
                this.updateInfoItem.videoUrl =response.data.replace(/\\/g,"/")
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('test/list',{
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'检测项目列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入检测名称');
                }
                if (this.itemAdd.introduction.length <= 0){
                    return this.$Message.warning('请输入检测介绍');
                }
                if (this.itemAdd.price.toString().length <= 0){
                    return this.$Message.warning('请输入检测价格');
                }
                // this.itemAdd.content = this.editor.txt.html();
                // this.itemAdd.otherIntro = this.otherIntroEditor.txt.html();
                
                this.itemAdd.content = this.addArticleContent;
                this.itemAdd.otherIntro = this.addOtherContent;
                if (this.itemAdd.content.length <= 0){
                    return this.$Message.warning('请输入病历内容');
                }
                this.addLoading = true
                this.$http.post('test/add',{
                    name: this.itemAdd.name,
                    introduction: this.itemAdd.introduction,
                    price: this.itemAdd.price,
                    content: this.itemAdd.content,
                    videoUrl: this.itemAdd.videoUrl,
                    otherIntro: this.itemAdd.otherIntro
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检测项目新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检测项目新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                console.log('this.updateInfoItem', this.updateInfoItem)
                // this.editorUpdate.txt.html(this.updateInfoItem.content)
                // this.otherIntroEditorUpdate.txt.html(this.updateInfoItem.otherIntro)
                this.editArticleContent = this.updateInfoItem.content
                this.editOtherContent = this.updateInfoItem.otherIntro
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.name.length <= 0){
                    return this.$Message.warning('请输入检测名称');
                }
                if (this.updateInfoItem.introduction.length <= 0){
                    return this.$Message.warning('请输入检测介绍');
                }
                if (this.updateInfoItem.price.toString().length <= 0){
                    return this.$Message.warning('请输入检测价格');
                }
                // this.updateInfoItem.content = this.editorUpdate.txt.html();
                // this.updateInfoItem.otherIntro = this.otherIntroEditorUpdate.txt.html();
                this.updateInfoItem.content = this.editArticleContent;
                this.updateInfoItem.otherIntro = this.editOtherContent;
                if (this.updateInfoItem.content.length <= 0){
                    return this.$Message.warning('请输入病历内容');
                }
                this.updateLoading = true
                this.$http.post('test/update',{
                    id: this.updateInfoItem.id,
                    name: this.updateInfoItem.name,
                    introduction: this.updateInfoItem.introduction,
                    price: this.updateInfoItem.price,
                    content: this.updateInfoItem.content,
                    videoUrl: this.updateInfoItem.videoUrl,
                    otherIntro: this.updateInfoItem.otherIntro
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检测项目修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检测项目修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd.name = this.itemAdd.introduction = ''
                this.itemAdd.price = 0
                this.itemAdd.videoUrl = null
                this.updateInfoItem.videoUrl = null
                this.editor.txt.clear()
                this.otherIntroEditor.txt.clear()
                this.editorUpdate.txt.clear()
                this.otherIntroEditorUpdate.txt.clear()
                this.$refs.uploadImageUpdate.clearFiles()
                this.$refs.uploadImageAdd.clearFiles()
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用检测项目“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('test/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检测项目启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检测项目启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用检测项目“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('test/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检测项目禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检测项目禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


